import React, { useEffect, useState } from "react";
import styles from "./PortalVer.module.css";
import Container from "../../layout/container/Container";
import Body from "../../layout/body/Body";
import Footer from "../../layout/Footer/Footer";
import NavBar from "../../layout/navbar/NavBar";
import LogoImg from "../../../assets/images/LOGO KIPIT.png";
import LoginForm from "../../components/formLogin/LoginForm";
import { Link, useLocation, useHistory } from "react-router-dom";

const PortalVer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };
  
  return (
    <Container>
      {/* <NavBar /> */}

      {/* <Body> */}
        {/* <div className={styles.Seccion}></div> */}


        <div
            className={styles.ModalLogin}
          >
            <div className={styles.SectionLeft}></div>

            <div className={styles.SectionRight}>
              <div className={styles.Logo}>
                <img src={LogoImg} alt="Logo" />
              </div>

              <LoginForm closeModal={handleOk} />

              <div className={styles.NoCuenta}>
                ¿No tienes una cuenta?{" "}
                <Link to="/register" className={styles.Registro}>
                  Regístrate
                </Link>
              </div>
            </div>
          </div>
      {/* </Body> */}

    </Container>
  );
};

export default PortalVer;
